import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, watch } from "vue";
import { IntegrationsStepperProps, StepperStep } from "@/types";
import {
  createProjectApiStore,
  integrationsApiStore,
  integrationsStore,
} from "@/hooks";
import { Stepper, PanelCard } from "@/components/common";
import { AuthenticationSelector } from "../authentication";
import { IntegrationSelector } from "../projects";


/**
 * Allows for creating a project from integrations sources.
 *
 * @emits-1 `submit` - On project submission.
 */
const __default__ = {
  name: "IntegrationsStepper",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const source = ref<"Jira" | "GitHub" | undefined>();
const currentStep = ref(1);
const steps = ref<StepperStep[]>([
  { title: "Connect to Source", done: false },
  { title: "Select Project", done: false },
]);

/**
 * Selects the type of integration to import from.
 * @param type - The type of integration.
 */
function handleSelectSource(type: "Jira" | "GitHub"): void {
  source.value = type;
}

/**
 * Attempts to import a project.
 */
function handleSaveProject(): void {
  const callbacks = {
    onSuccess: () => emit("submit"),
  };

  if (props.type === "create") {
    // Create a new project.
    if (source.value === "Jira") {
      createProjectApiStore.handleJiraImport(callbacks);
    } else if (source.value === "GitHub") {
      createProjectApiStore.handleGitHubImport(callbacks);
    }
  } else {
    // Sync with the current project.
    integrationsApiStore.handleNewSync(source.value, callbacks);
  }
}

watch(
  () => {
    if (source.value === "Jira") {
      return integrationsStore.validJiraCredentials;
    } else if (source.value === "GitHub") {
      return integrationsStore.validGitHubCredentials;
    } else {
      return false;
    }
  },
  (valid) => {
    if (valid) {
      currentStep.value = 2;
      steps.value[0].done = true;
    } else {
      currentStep.value = 1;
      steps.value[0].done = false;
    }
  }
);

watch(
  () => {
    if (source.value === "Jira") {
      return integrationsStore.jiraProject?.name;
    } else if (source.value === "GitHub") {
      return integrationsStore.gitHubProject?.name;
    } else {
      return undefined;
    }
  },
  (name) => {
    steps.value[1].done = !!name;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    minimal: props.type === 'connect'
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Stepper), {
        modelValue: currentStep.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentStep).value = $event)),
        minimal: props.type === 'connect',
        steps: steps.value,
        onSubmit: handleSaveProject
      }, {
        "1": _withCtx(() => [
          _createVNode(_unref(AuthenticationSelector), {
            modelValue: source.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((source).value = $event)),
            onInput: handleSelectSource
          }, null, 8, ["modelValue"])
        ]),
        "2": _withCtx(() => [
          (!!source.value)
            ? (_openBlock(), _createBlock(_unref(IntegrationSelector), {
                key: 0,
                source: source.value
              }, null, 8, ["source"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "minimal", "steps"])
    ]),
    _: 1
  }, 8, ["minimal"]))
}
}

})